import { Skeleton } from "primereact/skeleton";

const VehiclesSkeleton = () => {
    return (
        <div className="flex flex-column pt-5 px-3 gap-3 pb-6 align-items-center h-full">
            {[1, 2, 3].map((item) => (
                <Skeleton key={item} className="w-full" height="9rem" />
            ))}
        </div>
    );
}

export default VehiclesSkeleton;